import React, {useEffect, useCallback } from 'react';
import {useHistory} from 'react-router-dom';
import {Container, Overlay} from './styles';
import {IoMdClose} from 'react-icons/io';

import Financeiro from '../../assets/icones/icon_financeiro.svg';
import Rating from '../../assets/icones/icon_rating.svg';
import Report from '../../assets/icones/icon_report.svg';
import Training from '../../assets/icones/icon_training.svg';

const Menu = ({ open, close }) => {

    const history = useHistory();

    useEffect(() => {
        var lastScrollTop = 0;
        // document.addEventListener('keyup', escapeListener);
            window.addEventListener("scroll", function() {
            var ul = document.getElementById("ul");
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop && ul !== null) {
                ul.style.paddingTop = "96px";
            } else if (ul !== null) {
                ul.style.paddingTop = "129px";
            }
            lastScrollTop = st <= 0 ? 0 : st;
            }, false);
    }, [])

    const escapeListener = useCallback((e) => {
        if (e.key === 'Escape') {
          close()
        }
      }, [])

    function navigate(tela) {
        history.push(tela);
        close();
    }

        return (
            <Overlay open={open}>
            <Container open={open} id="ul">
                <button 
                    onClick={() => close()}
                    className="close">
                    <IoMdClose color="#b2aaaa" className="i-close" />
                </button>

                <li onClick={() => navigate('/avaliacoes')}>
                    <img alt="" src={Rating}
                        className="icones"/>
                    <h5>
                    Avaliações
                    </h5>
                </li>
                
                
                <li onClick={() => navigate('/minhas-vendas')}>
                    <img alt="" src={Report}
                        className="icones"/>
                    <h5>
                    Relatórios
                    </h5>
                </li>

                <li onClick={() => navigate('/ajuda')}>
                    <img alt="" src={Training}
                        className="icones"/>
                    <h5>
                    Ajuda
                    </h5>
                </li>

                {/* <li onClick={() => navigate('/treinamento')}>
                    <img alt="" src={Training}
                        className="icones"/>
                    <h5>Treinamento</h5>
                    </li> */}
                <li onClick={() => navigate('/financeiro')}>
                    <img alt="" src={Financeiro}
                        className="icones"/>
                <h5>Financeiro</h5>
                </li>
            </Container>
            </Overlay>
        )
}

export default Menu;